import React, { Component } from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

const styles = theme => ({
  seeAllContainer: {
    padding: '15px',
    display: 'flex',
    alignItems: 'left',
    flexDirection: 'row',
  },
  seeAllText: {
    marginTop: '15px',
    display: 'inline',
    position: 'absolute',
    right: '10px',
  },
  avatar: {
    width: '50px',
    height: '50px',
    border: '2px solid white',
  },
  nextAvatar: {
    width: '50px',
    height: '50px',
    marginLeft: '-25px',
    border: '2px solid white',
  },
});

class SeeAllContributors extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    const { classes, contributors } = this.props;
    const avatars = contributors.map((contributor, i) => (
      <Avatar
        key={'avatar' + i}
        className={i === 0 ? classes.avatar : classes.nextAvatar}
        style={{ zIndex: 100 - i }}
        alt={contributor.owner.firstName + ' ' + contributor.owner.lastName}
        src={contributor.owner.profilePic}
      />
    ));
    return (
      <div className={classes.seeAllContainer}>
        {avatars}
        <Typography className={classes.seeAllText} variant="subtitle2">
          SEE ALL CONTRIBUTORS
        </Typography>
      </div>
    );
  }
}

SeeAllContributors.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SeeAllContributors);
